import React, { Component } from 'react';
import './Cart--Item.css';

//import Input from './Input';

class CartDiscount extends Component {

  constructor(props) {
    super(props);

    this._updateQuantity = this._updateQuantity.bind(this);

    this.state = {
      
    };

  }

  componentWillReceiveProps(newProps) {

    this.setState({
      
    });

  }

  render() {

    return (
      
      <div className="Page cartRow"> 

        <div className="cartRow-info clearflex align-flex-start">
          <div className="two-thirds column">
            <p><strong>{this.props.name}</strong></p>
          </div>
          <div className="one-third column">
            <p><span className="total">{this.props.discount ? "-$"+this.props.discount.toFixed(2) : "None"}</span></p>
          </div>
        </div>

        <p className="cartRow-footer" style={this.props.name ? {} : {display:"none"}}>{this.props.code} - {this.props.name} <a className="removeDiscount" onClick={this.props.clearDiscount}>remove</a></p>

      </div>
            
    );  
  
  }

  _updateQuantity(quantity) {
    console.log(quantity);
  }

}

export default CartDiscount;


// WEBPACK FOOTER //
// ./src/components/Cart--Discount.js